import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeHoppBlogPost} from "./doppe-action-type-hopp-blog-post";

export const doppeActionTypeHoppBlogPostViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppBlogPost, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppBlogPostWidget: (await import('./doppe-action-type-hopp-blog-post-widget/doppe-action-type-hopp-blog-post-widget')).DoppeActionTypeHoppBlogPostWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeHoppBlogPostWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeHoppBlogPostWidget
                {...renderProps}
            />
        );
    },

    activateCTA: actionContext => {
        actionContext.navigateToUrl(actionContext.action.settings.blogPostLink, true);
    }
}); 